import { mapGetters } from "vuex";
import Tariff from "./TariffDetails/Tariff.vue";
import TariffDetails from "./TariffDetails/TariffDetails.vue";
import TariffDetailsTv from "./TariffDetails/TariffDetailsTv.vue";
import Navigation from "@checkout/components/Partials/Navigation.vue";
import SingleStep from "@checkout/components/Partials/SingleStep.vue";
import StepWrapper from '@checkout/components/Partials/StepWrapper.vue';
import storage from "@checkout/services/storage";
import router from "@checkout/router";
import stepsMixin from '@checkout/mixins/stepsMixin';

export default {
  name: "CheckoutStep1",

  mixins: [stepsMixin],

  components: {
    TariffDetailsTv,
    TariffDetails,
    Navigation,
    SingleStep,
    StepWrapper,
    Tariff,
  },

  computed: {
    ...mapGetters(["checkout", "steps", "isGeneralCheckout", "usePrepaidSteps"]),

    isTvCheckout() {
      return this.checkout && (this.checkout.type === 'TV Tariff' || this.checkout.type === 'Tv Device');
    },
  },

  methods: {
    proceedToNextStep() {
        router.push({ name: 'checkout-step-3' })
    },
  },

  beforeRouteLeave(to, from, next) {
    storage.save("page-step", 2, true);
    next();
  },
};
